import { Dialog, DialogPanel } from "@headlessui/react"
import { X } from "lucide-react"
import React from "react"
import { cn } from "../../utils/cn"

interface ModalProps {
    open: boolean
    onClose: () => void
    children: React.ReactNode
    className?: string
    size?: "md" | "lg" | "xl"
    hideClose?: boolean
}

const sizeClasses = {
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-3xl",
}

/** Modal acessível (focus-trap + ESC via headlessui) sobre a superfície `elevated`. */
const Modal: React.FC<ModalProps> = ({
    open,
    onClose,
    children,
    className,
    size = "md",
    hideClose,
}) => {
    return (
        <Dialog open={open} onClose={onClose} className="relative z-50">
            <div
                className="fixed inset-0 bg-black/60 backdrop-blur-sm"
                aria-hidden="true"
            />
            <div className="fixed inset-0 flex items-center justify-center overflow-y-auto p-4">
                <DialogPanel
                    className={cn(
                        "relative w-full rounded-2xl border border-border bg-elevated text-text shadow-elevated",
                        sizeClasses[size],
                        className
                    )}
                >
                    {!hideClose && (
                        <button
                            onClick={onClose}
                            aria-label="Fechar"
                            className="absolute right-4 top-4 inline-flex items-center justify-center rounded-full p-1.5 text-muted transition-colors hover:bg-surface hover:text-text focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60"
                        >
                            <X size={18} />
                        </button>
                    )}
                    {children}
                </DialogPanel>
            </div>
        </Dialog>
    )
}

export default Modal
